import React from "react";

export default function AboutPage({ setPage }) {
  return (
    <div style={{ padding: "20px" }}>
      <h2>О сервисе</h2>

      <p>
          Мы — сервис, который помогает найти своего специалиста без хаоса и бесконечных списков.
          <br />
          Мы выросли из коворкинга БЛИЗКО — места, где каждый день работают десятки профессионалов города.
          <br />
          Мы знаем их лично, видим, как они ведут практику, учатся и поддерживают друг друга.
      </p>

      <p>
          Поэтому мы не просто показываем анкеты. <br />
          Мы опираемся на живое профессиональное сообщество БЛИЗКО и подбираем человека, который действительно подойдёт вам по запросу, стилю и человеческому ощущению.
      </p>

        <p>
            Здесь безопасно, понятно и по‑человечески.<br />
            Вы выбираете из близких к Вам реальных специалистов, а не удалённых анкет, а мы Вам помогаем.
        </p>

        <p>Мы БЛИЗКО</p>

      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <button
          onClick={() => setPage("for-psychologists")}
          style={{
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#042204ff",
            color: "#fff",
            cursor: "pointer"
          }}
        >
          Для психологов
        </button>
      </div>
    </div>
  );
}
